import React from 'react';
import createSvgIcon from '../utils/createSvgIcon';

export default createSvgIcon(React.createElement(
  'g',
  { transform: 'translate(180.843 -10.001)' },
  React.createElement(
    'g',
    { transform: 'translate(-180.843 10.001)' },
    React.createElement('path', {
      d: 'M4.9,12.33l-1.24-.41A13.69,13.69,0,0,0,3.16,14l1.29.2a10.84,10.84,0,0,1,.45-1.87Z',
      transform: 'translate(0 0)'
    }),
    React.createElement('path', {
      d: 'M4.31,16.12H3a13.71,13.71,0,0,0,.19,2.13L4.49,18a12.35,12.35,0,0,1-.18-1.88Z',
      transform: 'translate(0 0)'
    }),
    React.createElement('path', {
      d: 'M13,4.71l-.33-1.26a13.12,13.12,0,0,0-2,.72l.54,1.19A11.2,11.2,0,0,1,13,4.71Z',
      transform: 'translate(0 0)'
    }),
    React.createElement('path', {
      d: 'M3.75,20.33a12.65,12.65,0,0,0,.88,2l1.13-.63A12.5,12.5,0,0,1,5,19.9Z',
      transform: 'translate(0 0)'
    }),
    React.createElement('path', {
      d: 'M6.69,8.93l-1-.78A12.49,12.49,0,0,0,4.5,10l1.15.61A11.54,11.54,0,0,1,6.69,8.93Z',
      transform: 'translate(0 0)'
    }),
    React.createElement('path', {
      d: 'M9.47,6.3,8.75,5.22A13.43,13.43,0,0,0,7.08,6.56L8,7.5A12.32,12.32,0,0,1,9.47,6.3Z',
      transform: 'translate(0 0)'
    }),
    React.createElement('path', {
      d: 'M12.88,28.62A12.64,12.64,0,0,0,15,29l.1-1.29a11.069,11.069,0,0,1-1.9-.31Z',
      transform: 'translate(0 0)'
    }),
    React.createElement('path', {
      d: 'M6.83,23.25l-1,.81a12.661,12.661,0,0,0,1.46,1.56l.88-1a11,11,0,0,1-1.34-1.37Z',
      transform: 'translate(0 0)'
    }),
    React.createElement('path', {
      d: 'M29,16h0v-.27h0a13.481,13.481,0,0,0-.21-2.12h0v-.06l-.09-.38c-.06-.25-.11-.51-.19-.76s-.08-.28-.13-.41-.09-.31-.14-.46h0a12.17,12.17,0,0,0-.89-1.94h0c-.08-.15-.18-.29-.27-.44l-.18-.28c-.16-.24-.32-.47-.49-.7l-.19-.24-.07-.11h0a12.7,12.7,0,0,0-1.47-1.55h0l-.17-.14c-.23-.19-.47-.39-.71-.57l-.37-.25c-.15-.1-.28-.21-.43-.3h0A13,13,0,0,0,21,4h0l-.32-.12-.47-.17-.67-.2-.44-.13h-.14A13.25,13.25,0,0,0,16.87,3h-.12a13.6,13.6,0,0,0-2,0l.13,1.29a13.092,13.092,0,0,1,3.95.32l.39.11.61.19.41.15a11.63,11.63,0,0,1,2.39,1.27L23,6.6l.61.49.18.15a12,12,0,0,1,1.43,1.51l.15.2c.16.21.31.42.46.65l.15.25a11.89,11.89,0,0,1,1.2,2.58,1.191,1.191,0,0,0,.1.32c.07.26.14.52.19.79l.06.24A11.61,11.61,0,0,1,27.69,16a7.667,7.667,0,0,1-.05,1.07,1.048,1.048,0,0,1-.05.39,11.59,11.59,0,0,1-.66,2.67l-.18.47-.25.54c-.07.13-.13.27-.21.41h0a10.831,10.831,0,0,1-1.15,1.73l-.28.33c-.14.17-.29.33-.44.49s-.31.33-.48.48l.88,1c.13-.12.24-.24.36-.36h0l.17-.19q.26-.27.48-.54l.32-.37.11-.13h0a12.78,12.78,0,0,0,1.43-2.3c.08-.17.17-.34.25-.52s.15-.38.22-.57.09-.23.14-.35h0a13.061,13.061,0,0,0,.52-2.07h0l.06-.5a1.384,1.384,0,0,1,.05-.45A11.46,11.46,0,0,0,29,16Z',
      transform: 'translate(0 0)'
    }),
    React.createElement('path', {
      d: 'M20.74,26.69l.53,1.19a12.15,12.15,0,0,0,1.87-1l-.71-1.08a12.59,12.59,0,0,1-1.69.89Z',
      transform: 'translate(0 0)'
    }),
    React.createElement('path', {
      d: 'M9,26.93a13.111,13.111,0,0,0,1.89,1l.51-1.19a11.11,11.11,0,0,1-1.7-.91Z',
      transform: 'translate(0 0)'
    }),
    React.createElement('path', {
      d: 'M17,27.65l.12,1.29a12.29,12.29,0,0,0,2.1-.36l-.32-1.26a12.179,12.179,0,0,1-1.9.33Z',
      transform: 'translate(0 0)'
    }),
    React.createElement('path', {
      d: 'M16.65,15.74v-8h-1.3V16a.6.6,0,0,0,.18.44L20.7,22l.94-.89Z',
      transform: 'translate(0 0)'
    })
  )
));